import { takeLatest, put } from 'redux-saga/effects';
import callRequestSaga from '~/sagas/utils/request-saga';
import YoutubeAPI from '~/api/youtube-api';
import { YoutubePlaylistContainerConstants } from '~/components/containers/YoutubePlaylistContainer/constants';
import {
  GetYoutubePlaylistActionType,
  GetYoutubeVideoLengthsActionType,
} from '~/components/containers/YoutubePlaylistContainer/types/actions.types';
import { getYoutubeVideoLengths } from '~/components/containers/YoutubePlaylistContainer/actions';
import BaseException from '~/utils/fetch-wrapper/errors/BaseException';

export function* getYoutubePlaylist({ payload }: GetYoutubePlaylistActionType) {
  const response = yield* callRequestSaga(
    YoutubeAPI.getPlaylist,
    {
      request: YoutubePlaylistContainerConstants.GET_YOUTUBE_PLAYLIST_REQUEST,
      failure:
        YoutubePlaylistContainerConstants.GET_YOUTUBE_PLAYLIST_REQUEST_ERROR,
      payload,
    },
    payload.playlistId
  );

  if (response instanceof BaseException) {
    return;
  }

  const mappedResult = YoutubeAPI.mapYoutubePlaylistResponse(response.items);

  yield put({
    type:
      YoutubePlaylistContainerConstants.GET_YOUTUBE_PLAYLIST_REQUEST_SUCCESS,
    response: mappedResult,
  });

  const videoIds = mappedResult.map((video) => video.videoId);
  yield put(getYoutubeVideoLengths(videoIds));
}

export function* getVideoLengths({
  payload,
}: GetYoutubeVideoLengthsActionType) {
  const response = yield* callRequestSaga(
    YoutubeAPI.getVideoLengths,
    {
      request: YoutubePlaylistContainerConstants.GET_VIDEO_LENGTHS_REQUEST,
      failure:
        YoutubePlaylistContainerConstants.GET_VIDEO_LENGTHS_REQUEST_ERROR,
      payload,
    },
    payload.videoIds
  );

  if (response instanceof BaseException) {
    return;
  }

  const mappedResult = YoutubeAPI.mapYoutubeVideoLengthsResponse(
    response.items
  );

  yield put({
    type: YoutubePlaylistContainerConstants.GET_VIDEO_LENGTHS_REQUEST_SUCCESS,
    response: mappedResult,
  });
}

function* getPlaylistSaga() {
  yield takeLatest(
    YoutubePlaylistContainerConstants.GET_YOUTUBE_PLAYLIST,
    getYoutubePlaylist
  );
}

function* getVideoLengthsSaga() {
  yield takeLatest(
    YoutubePlaylistContainerConstants.GET_VIDEO_LENGTHS,
    getVideoLengths
  );
}

export default [getPlaylistSaga, getVideoLengthsSaga];
